import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICountryRiskDataTableRowFormMeta {
    country: FormInputMeta;
    tran_aut: FormInputMeta;
    type: FormInputMeta;
    period: FormInputMeta;
    number: FormInputMeta;
    amount: FormInputMeta;

    schema: any;
}

const countryRiskDataTableRowFormMeta = {} as ICountryRiskDataTableRowFormMeta;

countryRiskDataTableRowFormMeta.country = {
    name: "country",
    type: "select",
    label: "Pays",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

countryRiskDataTableRowFormMeta.tran_aut = {
    name: "tran_aut",
    type: "select",
    label: "Tran/Aut",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

countryRiskDataTableRowFormMeta.type = {
    name: "type",
    type: "select",
    label: "Type",
    placeholder: "",
    validation: yup.string()
};

countryRiskDataTableRowFormMeta.period = {
    name: "period",
    type: "select",
    label: "Période",
    placeholder: "",
    validation: yup.string()
};

countryRiskDataTableRowFormMeta.number = {
    name: "number",
    type: "text",
    label: "Num",
    placeholder: "",
    validation: yup.string()
};

countryRiskDataTableRowFormMeta.amount = {
    name: "amount",
    type: "text",
    label: "Montant",
    placeholder: "",
    validation: yup.string()
};


countryRiskDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(countryRiskDataTableRowFormMeta));

export default countryRiskDataTableRowFormMeta;